import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { PrBuyerHelperService } from '../../../services/pr-buyer-helper.service';
import { RfqService } from '../../../services/rfq/rfq.service';
import * as JSZip from 'jszip';
import { IRFQAttachment, IRFQTemplateDetail } from '../../../models';
import { ToastrService } from 'ngx-toastr';
import { UI_MESSAGES } from 'src/app/app.contant';
import { BsModalRef } from 'ngx-bootstrap/modal';

interface FileSize {
  file : File,
  formatSize : string
}

interface IRFQAttachmentTab {
  name : string, 
  identifier : string
}

@Component({
  selector: 'rfq-attachments',
  templateUrl: './rfq-attachments.component.html',
  styleUrls: ['./rfq-attachments.component.scss']
})

export class RfqAttachmentsComponent implements OnInit {

  public rfqTemplateDetail !: IRFQTemplateDetail;

  // attachments variables
  public prFiles : Array<FileSize> = [];

  // tabs
  public attachmentTabs : Array<IRFQAttachmentTab> = [
    {
      name : "Upload files",
      identifier : "upload"
    },
    {
      name : "Uploaded files",
      identifier : "uploaded"
    }
  ];

  public activeTab : IRFQAttachmentTab = this.attachmentTabs[0];

  // already uploaded templates 
  public uploadedFiles : IRFQAttachment[] = [];

  constructor(private _helperService : PrBuyerHelperService, private _fb : FormBuilder,
    private _rfqService : RfqService,
    public bsModalRef: BsModalRef,
    private _toastrService: ToastrService) { }

  ngOnInit(): void {
    this.fetchRFQTemplates();
  }

  public onModalClose(): void {
    this.bsModalRef.hide();
  }

  private fetchRFQTemplates() : void {
    this._rfqService.fetchRFQTemplateAttachments(this.rfqTemplateDetail.id).subscribe((res : any) => {
      this.uploadedFiles = res.data;
    })
  }

  public changeTab = (tab : IRFQAttachmentTab) => this.activeTab = tab;

  public clearFile(file : File) : void {
    this.prFiles = this.prFiles.filter((x : FileSize) => x.file.name !== file.name)
  }

  public onFileChange(event : any) : void {
    [...event.target.files].forEach((file : File)=>{
      this.prFiles.push({file, formatSize : this._helperService.formatFileSize(file.size) })
    });
  }

  public validateFiles() : void {
    if(this.prFiles.length > 1) { //If more than one file, zip & send it over to the API
      this.uploadRFQFiles();
    } else if(this.prFiles.length === 1) {
      const formdata = new FormData();
      formdata.append("file", this.prFiles[0].file)
      this._rfqService.uploadRFQTemplateAttachment(formdata, this.rfqTemplateDetail.id).subscribe((res : any) => {
        this._toastrService.success(UI_MESSAGES.RFQ.TEMPLATE_UPLOAD);
        this.onModalClose();
      });
    }
  }

  public uploadRFQFiles() : void {
    console.log(this.prFiles);
    var zip : JSZip = new JSZip();
    this.prFiles.forEach((x : FileSize) => {
      zip.file(x.file.name, x.file);
    });
    zip.generateAsync({ type: 'blob' })
    .then((content : any) => { 
      const formdata = new FormData();
      // formdata.append("file", this.blobToFile(content, `Template-${new Date().toUTCString()}`));
      formdata.append("file", new File([content], `Template-${new Date().toUTCString()}.zip`))
      this._rfqService.uploadRFQTemplateAttachment(formdata, this.rfqTemplateDetail.id).subscribe((res : any) => {
        this._toastrService.success(UI_MESSAGES.RFQ.TEMPLATE_UPLOAD);
        this.onModalClose();
      });
    });
  }

  public blobToFile = (theBlob: Blob, fileName:string): File => {
    var b: any = theBlob;
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;
    //Cast to a File() type
    return <File>theBlob;
  }

  public downloadRFQtemplate(prFile : IRFQAttachment) : void {
    var zip = new JSZip();
    this.prFiles.forEach((x : FileSize) => {
      zip.file(x.file.name, x.file);
    });
    this._rfqService.downloadRFQTemplateAttachment(prFile.id).subscribe((res : any) => {
      this._helperService.saveFileData(res, prFile.name);
    });
  }

  public deleteRFQtemplate(id : any) : void {
    if(confirm(`Are you sure you want to delete this attachment?`)) {
      this._rfqService.deletedRFQTemplateAttachment(id).subscribe((res : any) => {
        this._toastrService.success(UI_MESSAGES.RFQ.DELETE_TEMPLATE_ATTACHMENT);
        this.uploadedFiles = this.uploadedFiles.filter((x : IRFQAttachment) => x.id !== id);
      });
    }
  }

}
